import NumberBar from './NumberBar';

export default NumberBar;
export { NumberBar };
